import * as React from "react";

const SvgIcon = ({ size = '64', color = '#f9a927' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    width={size}
    fill="none"
    version="1.1"
    viewBox="0 0 64 64"
  >
    <path
      fill={color}
      fillOpacity="1"
      d="m42.56 47.04 4.48-4.48L35.2 30.72V16h-6.4v17.28zM32 64q-6.64 0-12.48-2.522-5.84-2.52-10.16-6.838T2.522 44.48Q.002 38.637 0 32q-.004-6.636 2.522-12.48Q5.046 13.677 9.36 9.36t10.16-6.838Q25.367 0 32 0t12.48 2.522q5.846 2.52 10.16 6.838t6.842 10.16Q64.009 25.364 64 32t-2.522 12.48q-2.511 5.843-6.838 10.16-4.326 4.317-10.16 6.842T32 64m0-6.4q10.64 0 18.122-7.478Q57.602 42.644 57.6 32t-7.478-18.122Q42.647 6.4 32 6.4t-18.122 7.482T6.4 32t7.482 18.122Q21.367 57.606 32 57.6"
    ></path>
  </svg>
);

export default SvgIcon;
